import compose from "recompose/compose";
import withProps from "recompose/withProps";
import branch from "recompose/branch";
import { graphql } from "react-apollo";
import ProductReviewsQuery from "./ProductReviewsQuery.gql";
import { withRouter } from "react-router";
import qs from "web/core/utils/queryString";
import { REVIEWS_PAGE_LENGTH } from "./ProductReviewsConstants";

const EnhanceProductReviews = () =>
  compose(
    withRouter,
    withProps((props) => {
      const search = qs.parse(props.location.search);

      const page = Number(search?.page ?? 1);
      const reviewsOffset = (page - 1) * REVIEWS_PAGE_LENGTH;
      return {
        reviewsOffset,
        page: page,
        maxPage: Math.ceil(
          props.product.reviewsLayer.total / REVIEWS_PAGE_LENGTH
        ),
      };
    }),
    branch(
      (props) => props.reviewsOffset > 0,
      graphql(ProductReviewsQuery, {
        options: (props) => {
          return {
            variables: {
              sku: props.product.sku,
              reviewsLayerInput: {
                from: props.reviewsOffset,
                size: REVIEWS_PAGE_LENGTH,
              },
            },
          };
        },
        props: ({ data }) => {
          return {
            loading: data.loading,
            reviews: data.product?.reviewsLayer?.reviews,
          };
        },
      }),
      withProps(({ product }) => ({
        reviews: product.reviewsLayer.reviews,
      }))
    )
  );

export default EnhanceProductReviews;
